import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { Button } from "../design/button";
import { Divider } from "../design/divider";
import { FieldGroup, Fieldset, Label } from "../design/fieldset";
import { Heading } from "../design/heading";
import { Input } from "../design/input";
import { Field } from "@headlessui/react";

import logo from "../assets/logo.png";
import { Text } from "../design/text";
import { Link } from "../design/link";

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      // Configure action code settings to use custom URL
      const actionCodeSettings = {
        url: `${window.location.origin}/auth/action`,
        handleCodeInApp: true,
      };
      await sendPasswordResetEmail(auth, email, actionCodeSettings);
      setIsPasswordReset(true);
    } catch (error) {
      console.error("Authentication error", error);
      alert(error);
    }
    setIsSubmitting(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-zinc-900 dark:via-zinc-800 dark:to-zinc-900">
      <form
        method="post"
        className="w-full max-w-lg p-8 bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-white/20 dark:bg-zinc-900/80 dark:border-zinc-700/50"
        onSubmit={handleSubmit}
      >
        <img src={logo} alt="Logo" className="w-24 h-24 mx-auto" />
        <Fieldset>
          <Heading className="text-2xl font-bold text-center text-zinc-900 dark:text-white">
            Forgot Password
          </Heading>
          <Divider className="my-6" />
          {isPasswordReset && (
            <>
              <Text className="text-center text-zinc-600 dark:text-zinc-400">
                We've sent you an email with instructions on how to reset your
                password.
              </Text>
              <Divider className="my-6" />
              <Button onClick={() => navigate("/login")} className="w-full">
                Back to Login
              </Button>
            </>
          )}
          {!isPasswordReset && (
            <>
              <FieldGroup>
                <Field>
                  <Label htmlFor="email" className="text-sm font-medium text-zinc-700 dark:text-zinc-300">Email</Label>
                  <Input
                    id="email"
                    aria-label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                  />
                </Field>
              </FieldGroup>
              <Divider className="my-6" />
              <Button type="submit" className="w-full" disabled={isSubmitting}>
                {isSubmitting
                  ? "Sending email..."
                  : "Send Password Reset Email"}
              </Button>
              <div className="my-6 text-center">
                <Text className="text-zinc-600 dark:text-zinc-400">
                  <Link href="/login" className="text-blue-600 dark:text-blue-400 hover:underline">
                    Wait I remember my password
                  </Link>
                </Text>
              </div>
            </>
          )}
        </Fieldset>
      </form>
    </div>
  );
};

export default ForgotPasswordPage;
